module.exports = __webpack_public_path__ + "static/media/arrow-up.0b0d1af9.png";